<div class="available-organizations-column">
  <avano-table [headerText]="translationKeys.twinTableSelectComponent.html.availableOrganizations | translate" [tableRef]="availableOrganizationsTable">
    <!-- Table with the original Selection Data -->
    <p-table
      #availableOrganizationsTable
      [columns]="tableColumnConfig"
      [value]="twinTableData"
      [selectionMode]="'multiple'"
      [scrollable]="true"
      [selection]="tableOneSelection"
      (selectionChange)="setTableOneSelection($event)"
      [scrollHeight]="'180px'"
      [paginator]="false"
      [autoLayout]="true"
      [responsive]="true"
      [resizableColumns]="true"
      [lazy]="false"
      [loading]="loading"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns; let i = index" [avanoTableColumnHeader]="col" [isLastSortable]="i === columns.length - 1">
            <avano-text-input-column-filter
              [filterField]="col.field"
              style="flex-grow: 1"
              [style.visibility]="col.filterable === false ? 'hidden' : 'visible'"
            ></avano-text-input-column-filter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns">
            <div *ngIf="col.field === 'verified'; then verified; else otherCheck"></div>

            <ng-template #otherCheck>
              <div *ngIf="col.field === 'name'; then name; else others"></div>
            </ng-template>

            <ng-template #others>
              {{ rowData | nestedProperty: col.field }}
            </ng-template>
            <ng-template #name>
              <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                <i class="icon-content-badge" [style.visibility]="rowData['primary'] !== true ? 'hidden' : 'visible'"></i>
                {{ rowData | nestedProperty: col.field }}
              </div>
            </ng-template>
            <ng-template #verified>
              <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                <i
                  *ngIf="rowData[col.field] === true && rowData['validationErrors'] == null"
                  class="icon-content-success dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #008800"
                ></i>
                <i
                  *ngIf="rowData[col.field] === true && rowData['validationErrors']"
                  class="icon-content-error dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #cc0000"
                  (click)="showErrorDetails(rowData['validationErrors'])"
                ></i>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </avano-table>
</div>
<div class="button-area-column">
  <button
    avanoButton
    class="behaviorButton"
    [icon]="'icon-content-move-right'"
    [disabled]="tableOneSelection.length === 0"
    (click)="selectionLeftToRight()"
  ></button>
  <button
    avanoButton
    class="behaviorButton"
    [icon]="'icon-content-move-left'"
    [disabled]="tableTwoSelection.length === 0"
    (click)="selectionRightToLeft()"
  ></button>
  <button avanoButton class="behaviorButton" [icon]="'icon-content-move-all-right'" [disabled]="twinTableData.length === 0" (click)="allLeftToRight()"></button>
  <button avanoButton class="behaviorButton" [icon]="'icon-content-move-all-left'" [disabled]="selectionData.length === 0" (click)="allRightToLeft()"></button>
</div>
<div class="selected-organizations-column">
  <avano-table [headerText]="translationKeys.twinTableSelectComponent.html.selectedOrganizations | translate" [tableRef]="selectedOrganizationsTable">
    <!-- Table with the Selection Data -->
    <p-table
      #selectedOrganizationsTable
      [columns]="tableColumnConfig"
      [value]="selectionData"
      [selectionMode]="'multiple'"
      [scrollable]="true"
      [selection]="tableTwoSelection"
      (selectionChange)="setTableTwoSelection($event)"
      [scrollHeight]="'180px'"
      [paginator]="false"
      [autoLayout]="true"
      [responsive]="true"
      [resizableColumns]="true"
      [lazy]="false"
      [loading]="loading"
      [sortField]="tableColumnConfig[0].field"
      [sortOrder]="1"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns; let i = index"
            [avanoTableColumnHeader]="col"
            [pSortableColumn]="col.field"
            [isLastSortable]="i === columns.length - 1"
          >
            <avano-text-input-column-filter
              [filterField]="col.field"
              style="flex-grow: 1"
              [style.visibility]="col.filterable === false ? 'hidden' : 'visible'"
            ></avano-text-input-column-filter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns">
            <div *ngIf="col.field === 'verified'; then verified; else otherCheck"></div>

            <ng-template #otherCheck>
              <div *ngIf="col.field === 'name'; then name; else others"></div>
            </ng-template>

            <ng-template #others>
              {{ rowData | nestedProperty: col.field }}
            </ng-template>
            <ng-template #name>
              <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                <i class="icon-content-badge" [style.visibility]="rowData['primary'] !== true ? 'hidden' : 'visible'"></i>
                {{ rowData | nestedProperty: col.field }}
              </div>
            </ng-template>

            <ng-template #verified>
              <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                <i
                  *ngIf="rowData[col.field] === true && rowData['validationErrors'] == null"
                  class="icon-content-success dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #008800"
                ></i>
                <i
                  *ngIf="rowData[col.field] === true && rowData['validationErrors']"
                  class="icon-content-error dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #cc0000"
                  (click)="showErrorDetails(rowData['validationErrors'])"
                ></i>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </avano-table>
</div>

<scip-dossier-error-details-dialog
  *ngIf="showDossierErrorDetails"
  [header]="translationKeys.organizationTableComponent.html.organizationErrorDialogTitle | translate"
  [dossierError]="selectedDossierError"
  (closeDialog)="showDossierErrorDetails = false"
></scip-dossier-error-details-dialog>
